<template>
    <div class="container">
        <h3>公开信息披露</h3>
        <div class="content">
            <div class="item">
                <h4>法定名称：</h4>
                <div>嘉信保险经纪有限公司</div>
            </div>
            <div class="item">
                <h4>法定代表人：</h4>
                <div>陈旭</div>
            </div>
            <div class="item">
                <h4>注册资本：</h4>
                <div>人民币5500万</div>
            </div>
            <div class="item">
                <h4>成立时间：</h4>
                <div>2005年11月21日</div>
            </div>
            <div class="item">
                <h4>机构住所：</h4>
                <div>广州市天河区兴民路222号之三805室（部位：A）</div>
            </div>
            <div class="item">
                <h4>分支机构：</h4>
                <div>详见
                    <router-link to="/linkto">关于我们</router-link>
                </div>
            </div>
            <div class="item">
                <h4>营业执照及保险经营许可证</h4>
                <Row>
                    <Col span="8" :xs="24" :sm="8">
                    <div class="listItem">
                        <img src="../../assets/card2.jpg" />
                    </div>
                    </Col>
                    <Col span="8" :xs="24" :sm="8">
                    <div class="listItem">
                        <img src="../../assets/card1.jpg" />
                    </div>
                    </Col>
                    <Col span="8" :xs="24" :sm="8">
                    <div class="listItem">
                        <img src="../../assets/card3.png" />
                    </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>
<script>
import buslicence from '../../assets/buslicence.png'
export default {
    name: 'index',
}
</script>
<style scoped lang="less">
@media screen and (max-width: 767px) {
    .container {
        padding-top:64px; 
        font-size: 14px;
    h3 {
      font-size: 18px;
      color: #333333;
      padding: 0 20px 20px;
      border-bottom: 1px solid #eaeaea;
      position: relative;
      &:before {
        display: inline-block;
        content: "";
        height: 26px;
        width: 5px;
        background-color: #f3981b;
        position: absolute;
        left: 0;
        top: 4px;
      }
    }
    .content {
      padding: 30px 20px;
      color: #666666;
      .item {
        margin-bottom: 10px;
        h4 {
          color: #333333;
          font-weight: 400;
          font-size: 16px;
        }
        img {
          width: 100%;
        }
      }
    }
  }
}
@media screen and (min-width: 768px) {
  .container {
    font-size: 14px;
    h3 {
      font-size: 24px;
      color: #333333;
      padding: 0 20px 20px;
      border-bottom: 1px solid #eaeaea;
      position: relative;
      &:before {
        display: inline-block;
        content: "";
        height: 26px;
        width: 5px;
        background-color: #f3981b;
        position: absolute;
        left: 0;
        top: 4px;
      }
    }
    .content {
      padding: 30px 20px;
      color: #666666;
      .item {
        margin-bottom: 10px;
        h4 {
          color: #333333;
          font-weight: 400;
          font-size: 16px;
        }
        .listItem {
          width: 100%;
          height: 320px;
          position: relative;
          img {
            width: 100%;
            position: absolute;
            top: 30px;
            padding: 0 10px;
            box-sizing: border-box;
          }
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/page/PublicInfo/index.vue